export default {
  root: 'text-brand-text dark:text-surface-0/80 outline-0 pt-[0.375rem]'
}
